import "@/App.css";
import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { CredentialStrip } from "@/components/CredentialStrip";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Approach } from "@/components/Approach";
import { WhoWeWorkWith } from "@/components/WhoWeWorkWith";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div
      data-testid="app-root"
      style={{
        background: "var(--bg-primary)",
        minHeight: "100vh",
      }}
    >
      <Navigation />
      <Hero />
      <CredentialStrip />
      <About />
      <Services />
      <Approach />
      <WhoWeWorkWith />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
